import currencyLib from "currency.js";
import { useAppSelector } from "../../../services/hooks/useReduxHooks";
import { useTranslationI18 } from "../../../services/hooks/useTranslationI18";
import { localizedNumber } from "../../../utils/help/localization/localization";
import { ItemType } from "../../../utils/types";
import styles from "./DiscountedPriceV2.module.scss";

export const DiscountedPriceV2 = (props: {
  item: ItemType;
  isValidOffer: boolean;
  subItemIndex?: number;
  style?: {
    smallGap?: boolean;
  };
}) => {
  const { t } = useTranslationI18();
  const currency = useAppSelector((state) => state.config.currency);

  const { item, isValidOffer, subItemIndex, style } = props;

  const returnedPrice = (price: number) => {
    return (
      <div>
        <span data-testid="item_price">{Boolean(price) && currency}</span>
        <span>
          {price ? localizedNumber(price) : t("common:price-on-selection")}
        </span>
      </div>
    );
  };

  return (
    <div
      className={`${styles.container} ${
        style?.smallGap ? styles.small_gap : ""
      }`}
    >
      <span data-testid={`item_price-${item.subItems[subItemIndex || 0].name}`}>
        {returnedPrice(
          currencyLib(item.subItems[subItemIndex || 0].price).value
        )}
      </span>
      {isValidOffer && (
        <del className={styles.old_price}>
          {returnedPrice(
            currencyLib(item.subItems[subItemIndex || 0].previousPrice).value
          )}
        </del>
      )}
    </div>
  );
};
